export default __webpack_public_path__ + "static/media/nucleo.35b08447.ttf";